import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import Config from 'Config';
import MotiliTextButton from 'common/components/buttons/MotiliTextButton';
import { getNotApplicationFiles } from 'common/components/file-upload/FileUploadDropzone';
import { assignFilePreview, assignRejectionPreview } from 'common/utils/Utils';

import styles from '../../DocumentRequirementsPhotos.module.scss';

export const DropZoneWithNA = ({ id, text, disabled, handleOnDrop }) => {
    const { getRootProps, getInputProps, open } = useDropzone({
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'application/pdf': [],
        },
        onDrop: (acceptedFiles, rejectedFiles) => {
            const _acceptedFiles = acceptedFiles?.map(assignFilePreview);
            const _rejectedFiles = rejectedFiles?.map(assignRejectionPreview);

            handleOnDrop(_acceptedFiles, _rejectedFiles);
        },
        disabled,
        multiple: false,
        noClick: true,
        noKeyboard: true,
    });

    return (
        <>
            <div {...getRootProps({ style: { display: 'inline' } })}>
                <input {...getInputProps()} id={id} />
            </div>

            <MotiliTextButton
                disabled={disabled}
                moStyle='normal'
                text={text}
                onClick={open}
            />

            <div className={styles.buttonSeparator} />
            <MotiliTextButton
                disabled={disabled}
                text='NOT APPLICABLE'
                color={Config.color.darkCharcoal}
                onClick={() => handleOnDrop(getNotApplicationFiles(), [])}
            />
        </>
    );
};

DropZoneWithNA.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    handleOnDrop: PropTypes.func.isRequired,
};
